<template>
  <div>
    <!-- Match Info -->
    <el-row class="online-status-bar">
      <div class="status d-flex">
        <div class="online d-flex" :class="{ off: !networkOnline }">
          <div class="auto-margin">
            <i class="el-icon-sort"></i>
          </div>
        </div>
        <div class="saved d-flex" :class="{
          [syncStatus]: true,
        }">
          <div class="auto-margin">
            {{
              syncStatus === "syncing"
                ? "Syncing ..."
                : syncStatus === "out-of-sync"
                  ? "Offline"
                  : "Synced"
            }}
          </div>
        </div>
      </div>
    </el-row>
    <el-row :gutter="20">
      <el-col>
        <match v-if="match && match.round" :match="match" />
      </el-col>
    </el-row>

    <!-- Period  -->
    <el-row class="mt-1">
      <el-col :span="24" class="button-container">
        <el-button :disabled="isFinal" v-for="{ name, type } in grassrootGameStates"
          @click="period === type ? manualVestRotation() : confirmGameState(type)" :key="type"
          :type="period === type ? (isFinal ? 'default' : 'success') : 'default'">
          {{ name }}
        </el-button>
      </el-col>
    </el-row>

    <!-- Scoring, Interchange, Feed tabs -->
    <el-row class="tw-mt-1">
      <el-col>
        <el-tabs v-model="activeEvent" :stretch="true">
          <el-tab-pane label="Scoring" name="scoring" :disabled="match && !match.allowScoring">
            <el-table :data="playerScoring" :show-header="false" style="width: 100%">
              <el-table-column width="70">
                <template slot-scope="scope">
                  <i class="icon el-icon-circle-plus" @click="
                    doScoring({
                      name: scope.row.name,
                      type: scope.row.type,
                      value: scope.row.value,
                      teamId: match && match.homeTeam && match.homeTeam._id,
                      isHomeTeam: true,
                    })
                    "></i>
                </template>
              </el-table-column>
              <el-table-column prop="name" align="center" class-name="event-label"></el-table-column>
              <el-table-column width="70" align="right">
                <template slot-scope="scope">
                  <i class="icon el-icon-circle-plus" @click="
                    doScoring({
                      name: scope.row.name,
                      type: scope.row.type,
                      value: scope.row.value,
                      teamId: match && match.awayTeam && match.awayTeam._id,
                      isHomeTeam: false,
                    })
                    "></i>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Interchange" name="interchange">
            <el-table :data="playerInterchanges" :show-header="false" style="width: 100%">
              <el-table-column width="70">
                <template slot-scope="scope">
                  <i class="icon el-icon-circle-plus" @click="
                    doInterchange({
                      name: scope.row.name,
                      type: scope.row.type,
                      teamId: match && match.homeTeam && match.homeTeam._id,
                      isHomeTeam: true,
                    })
                    "></i>
                </template>
              </el-table-column>
              <el-table-column prop="name" align="center" class-name="event-label"></el-table-column>
              <el-table-column width="70" align="right">
                <template slot-scope="scope">
                  <i class="icon el-icon-circle-plus" @click="
                    doInterchange({
                      name: scope.row.name,
                      type: scope.row.type,
                      teamId: match && match.awayTeam && match.awayTeam._id,
                      isHomeTeam: false,
                    })
                    "></i>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Feed" name="feed">
            <el-table v-if="feedEvents && feedEvents.length > 0" :data="feedEvents" :show-header="false"
              style="width: 100%">
              <el-table-column width="60">
                <template slot-scope="scope">
                  <span style="font-size: 14px; text-transform: uppercase; font-weight: 500">{{
                    formatTime(scope.row.min) }}:{{ formatTime(scope.row.sec) }}</span>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <div style="font-size: 14px; text-transform: uppercase; font-weight: 500">
                    {{ scope.row.name }} - {{ scope.row.isHomeTeam ? "HOME" : "AWAY" }}
                  </div>
                  <div v-if="scope.row.isScoring">
                    {{
                      scope.row.meta.player ? displayPlayerName(scope.row.meta.player.profile) : ""
                    }}
                  </div>
                  <div v-if="!scope.row.isScoring">
                    <div v-if="scope.row.meta.on">
                      On:
                      {{ displayPlayerName(scope.row.meta.on.profile) }}
                    </div>
                    <div v-if="scope.row.meta.off">
                      Off:
                      {{ displayPlayerName(scope.row.meta.off.profile) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="right" width="60" v-if="match.status !== 'final'">
                <template slot-scope="scope">
                  <i class="icon el-icon-remove" @click="removeEvent(scope.row._id, scope.row.isScoring)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="Vests" name="vests" v-if="availVestTypes.length">
            <el-table v-if="vests && vests.length > 0" :data="vests" :show-header="false" style="width: 100%">
              <el-table-column width="100" prop="periodName"> </el-table-column>
              <el-table-column width="60" prop="teamName"> </el-table-column>
              <el-table-column width="60" prop="vestType"> </el-table-column>
              <el-table-column align="right" width="auto">
                <template slot-scope="scope">
                  <div style="font-size: 14px; text-transform: uppercase; font-weight: 500">
                    {{ scope.row.playerName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="right">
                <template slot-scope="scope">
                  <i class="icon el-icon-remove" @click="removeVest(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- Scoring Dialog -->
    <el-dialog :title="scoring.name" :visible.sync="scoringDialog" @close="
      scoringDialog = false;
    scoring.meta.player = undefined;
    ">
      <el-form label-position="top" :model="scoring" :rules="scoringRules" ref="scoring">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item prop="meta.player._id" label="Player">
              <select v-model="scoring.meta.player" :class="scoring.meta.player !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
                ">
                <option :value="undefined" selected>Unknown</option>
                <option v-for="item in scoring.isHomeTeam ? homeList : awayList" :key="item._id" :value="item">
                  {{ `${displayPlayerName(item.profile)} #${item.shirtNum}` }}
                </option>
              </select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="min" label="Minute">
              <input class="input tw-appearance-none" type="number" min="0" value="0" v-model="scoring.min" :class="scoring.min > 0 ? 'tw-font-medium tw-text-black' : 'tw-font-normal tw-text-black'
                " />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sec" label="Second">
              <input class="input tw-appearance-none" type="number" min="0" max="59" value="0" v-model="scoring.sec"
                :class="scoring.sec > 0 ? 'tw-font-medium tw-text-black' : 'tw-font-normal tw-text-black'
                  " />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="tw-mt-3">
          <button class="btn-success" :disabled="isFinal" type="success" @click.prevent="submitScore">
            Submit
          </button>
          <button class="btn-cancel" @click.prevent="
            scoringDialog = false;
          scoring.meta.player = undefined;
          ">
            Cancel
          </button>
        </div>
      </el-form>
    </el-dialog>

    <!-- Interchange Dialog -->
    <el-dialog :title="interchange.name" :visible.sync="interchangeDialog" @close="
      interchangeDialog = false;
    interchange.meta.off = undefined;
    interchange.meta.on = undefined;
    ">
      <el-form label-position="top" :model="interchange" :rules="interchangeRules" ref="interchange">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item prop="meta.off._id" label="Player off">
              <select v-model="interchange.meta.off" id="interchange-off" :class="interchange.meta.off !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
                ">
                <option disabled :value="undefined" selected>Select Player</option>
                <option v-for="item in offPlayers(interchange.isHomeTeam ? homeList : awayList)" :key="item._id"
                  :value="item">
                  {{ `${displayPlayerName(item.profile)} #${item.shirtNum}` }}
                </option>
              </select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="meta.on" label="Player on">
              <select v-model="interchange.meta.on" id="interchange-on" :class="interchange.meta.on !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
                ">
                <option disabled :value="undefined" selected>Select Player</option>
                <option v-for="item in onPlayers(interchange.isHomeTeam ? homeList : awayList)" :key="item._id"
                  :value="item">
                  {{ `${displayPlayerName(item.profile)} #${item.shirtNum}` }}
                </option>
              </select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="min" label="Minute">
              <input class="input" type="number" value="1" placeholder="1" min="1" v-model="interchange.min"
                id="time-min" :class="interchange.min ? 'tw-font-medium tw-text-black' : 'tw-font-normal tw-text-black'
                  " />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="sec" label="Second">
              <input class="input" type="number" min="0" max="59" placeholder="0" value="0" v-model="interchange.sec"
                id="time-sec" :class="interchange.sec > 0
                    ? 'tw-font-medium tw-text-black'
                    : 'tw-font-normal tw-text-black'
                  " />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="tw-mt-2">
          <button class="btn-success" :disabled="isFinal" type="success" @click.prevent="submitInterchange">
            Submit
          </button>
          <button class="btn-cancel" @click.prevent="
            interchangeDialog = false;
          interchange.meta.off = null;
          interchange.meta.on = null;
          ">
            Cancel
          </button>
        </div>
      </el-form>
    </el-dialog>

    <!-- Vest Rotation Dialog -->
    <el-dialog title="Vest Rotation" :visible.sync="vestRotationDialog" custome-class="vest-rotation-class" @close="
      vestRotationDialog = false;
    awayVests = [];
    homeVests = [];
    ">
      <el-form label-position="top" :model="vestRotations" ref="vestRotation">
        <el-row :gutter="5" v-if="!isManualVest">
          <select v-model="manualVestPeriod" :class="manualVestPeriod ? 'tw-font-medium tw-text-black' : 'tw-font-normal tw-text-black'
            ">
            <option v-for="{ name, type } in grassrootGameStates" :key="type" :label="name" :value="type">
              {{ name }}
              >
            </option>
          </select>
        </el-row>
        <h3>Home Team - {{ match && match.homeTeam && match.homeTeam.name }}</h3>
        <el-row :gutter="5" v-for="(vest, index) in homeVests" :key="`home-${index}`">
          <el-col :span="24">
            <el-form-item prop="player" :label="formatVestLabel(homeVests[index].vestType)">
              <select v-model="homeVests[index].player" :class="homeVests[index].player !== null
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
                ">
                <option disabled :value="null" selected>Select Player</option>
                <option v-for="item in vestHomePlayers(index, homeList)" :key="item._id" :value="item">
                  {{ `${displayPlayerName(item.profile)} #${item.shirtNum}` }}
                </option>
              </select>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>Away Team - {{ match && match.awayTeam && match.awayTeam.name }}</h3>
        <el-row :gutter="5" v-for="(vest, index) in awayVests" :key="`away-${index}`">
          <el-col :span="24">
            <el-form-item prop="player" :label="formatVestLabel(awayVests[index].vestType)">
              <select v-model="awayVests[index].player" :class="awayVests[index].player !== null
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
                ">
                <option disabled :value="null" selected>Select Player</option>
                <option v-for="item in vestAwayPlayers(index, awayList)" :key="item._id" :value="item">
                  {{ `${displayPlayerName(item.profile)} #${item.shirtNum}` }}
                </option>
              </select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="mt-1">
          <button class="btn-success" type="success" @click.prevent="submitVestRotation">
            Submit
          </button>
          <button class="btn-cancel" @click.prevent="
            vestRotationDialog = false;
          awayVests = [];
          homeVests = [];
          ">
            Cancel
          </button>
        </div>
      </el-form>
    </el-dialog>

    <!-- End game dialog -->
    <el-dialog title="End game" :visible.sync="confirmEndGameDialog" width="80%" top="30vh">
      <div style="word-break: keep-all">
        Are you sure you want to end the game with the following score ?
      </div>
      <el-form label-position="top" :model="match.scores" class="mt-1" ref="finalScore">
        <el-row :gutter="5">
          <el-col :span="12">
            <el-form-item prop="homeTeam">
              <input class="input" type="number" min="0" :disabled="match.allowScoring === false"
                v-model="match.scores.homeTeam" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="awayTeam">
              <input class="input" type="number" min="0" :disabled="match.allowScoring === false"
                v-model="match.scores.awayTeam" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer footer-customize" style="text-align: center">
        <button
          class="tw-justify-center tw-w-full tw-mt-2 tw-mr-2.5 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64"
          type="success" size="small" @click="
            period = 25;
          updateGameState();
          ">
          Confirm
        </button>
        <button class="btn-cancel tw-mr-2.5" size="small" @click="confirmEndGameDialog = false">
          Cancel
        </button>
      </span>
    </el-dialog>

    <!-- Disputed dialog -->
    <el-dialog title="DISPUTE MATCH" :visible.sync="disputeDialog" width="80%" top="30vh">
      <el-form v-model="dispute">
        <el-form-item label="Dispute reason">
          <textarea class="textBox" rows="2" v-model="dispute.reason"></textarea>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="btn-success" type="success" size="small" @click="submitDisputeMatch">
          Submit
        </button>
        <button class="btn-cancel tw-mr-2.5" size="small" @click="disputeDialog = false">
          Cancel
        </button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _ from "lodash";
import dayjs from "@/utils/dayjs";
import generateHash from "random-hash";
import Match from "../../components/MatchCard.vue";
import {
  errormsg,
  roles,
  nrlScoring,
  tfaScoring,
  interchanges,
  grassrootGameStates,
  vestTypes,
} from "../../utils/constants";
import { EventBus } from "../../bus";

export default {
  name: "MatchDetail",
  components: {
    Match,
  },
  data() {
    return {
      vestTypes,
      availVestTypes: [],
      grassrootGameStates,
      networkOnline: true,
      outOfSync: false,
      vestRotationDialog: false,
      scoringDialog: false,
      interchangeDialog: false,
      confirmEndGameDialog: false,
      nrlScoring,
      tfaScoring,
      interchanges,
      activeEvent: "scoring",
      roles,
      screen: "",
      teamId: "",
      period: null,
      homeList: [],
      awayList: [],
      isManualVest: false,
      match: {
        playerMovements: [],
        scoringEvents: [],
        gameStates: [],
        scores: {
          homeTeam: 0,
          awayTeam: 0,
        },
      },
      scoring: {
        _id: "",
        name: "",
        type: "",
        value: "",
        teamId: "",
        isHomeTeam: false,
        min: 0,
        sec: 0,
        meta: {
          player: undefined,
          period: 1,
        },
      },
      scoringRules: {
        "meta.player._id": {
          required: false,
          message: errormsg.select_option,
          trigger: "blur",
        },
        min: {
          required: true,
          message: errormsg.input_option,
          trigger: "change",
        },
        sec: {
          required: true,
          message: errormsg.input_option,
          trigger: "change",
        },
      },
      interchange: {
        _id: "",
        name: "",
        type: "",
        teamId: "",
        isHomeTeam: false,
        min: "",
        sec: "",
        meta: {
          off: undefined,
          on: undefined,
          period: 1,
        },
      },
      interchangeRules: {
        min: {
          required: true,
          message: errormsg.input_option,
          trigger: "change",
        },
        sec: {
          required: true,
          message: errormsg.input_option,
          trigger: "change",
        },
      },
      homeVests: [],
      awayVests: [],
      vestRotations: {},
      disputeDialog: false,
      manualVestPeriod: null,
      dispute: {
        reason: "",
      },
    };
  },
  mounted() {
    const { matchId: id, teamId } = this.$route.params;

    // header menu handlers
    const eventName = `${this.$route.name}-header-menu`;
    const listener = (type) => {
      switch (type) {
        case "go-team-list":
          // must turn this listener off due to router's push event will create new instance.
          if (this.networkOnline) {
            this.$router.push({
              name: "teamLists.management",
              params: this.$route.params,
            });
          } else {
            this.$customError(errormsg.no_internet_tl);
          }
          break;
        case "dispute-match":
          if (this.networkOnline) {
            this.disputeDialog = true;
          } else {
            this.$customError(errormsg.no_internet_dispute);
          }
          break;
        default:
          break;
      }
    };

    this.$root.$on(eventName, listener);

    if (teamId) {
      this.teamId = teamId;
    }

    this.$store.commit("root/loading", true);
    this.$http
      .get(`nrl/api/v1/admin/matches/${id}`)
      .then((matchRes) => {
        this.match = Object.assign({}, this.match, matchRes.data.data);

        // check if tba or bye match return to matches
        if (this.match && this.match.meta && (this.match.meta.isTba || this.match.meta.isBye)) {
          this.$router.push("/matches");
          return;
        }

        // grassrootGameStates
        const removedIndexes = _.range(this.match.periods, 4);
        this.grassrootGameStates = this.grassrootGameStates.filter(
          (x, index) => !removedIndexes.includes(index)
        );

        // last state
        const lastState = _.last(this.match.gameStates);
        // set period by last state || First Half(1)
        this.period = lastState && lastState.type;

        // specify available vest types for the match, base on competition ageLvl && only avail on NRL
        if (this.$store.getters["user/activeRole"].national_id === 32) {
          this.availVestTypes = this.vestTypes.filter((x) => x.ageLvls.includes(this.match.ageLvl));
        }

        // get players from team lists
        Promise.all([
          this.$http.get(
            `nrl/api/v1/admin/teamlists/teams/${this.match.homeTeam._id}/matches/${id}`
          ),
          this.$http.get(
            `nrl/api/v1/admin/teamlists/teams/${this.match.awayTeam._id}/matches/${id}`
          ),
        ])
          .then(([homeListRes, awayListRes]) => {
            if (homeListRes.data.data && homeListRes.data.data.length)
              this.homeList = homeListRes.data.data[0].players;
            if (awayListRes.data.data && awayListRes.data.data.length)
              this.awayList = awayListRes.data.data[0].players;

            this.$store.commit("root/loading", false);
          })
          .catch(() => {
            this.$store.commit("root/loading", false);
          });
      })
      .catch(() => {
        this.$store.commit("root/loading", false);
      });
  },
  methods: {
    manualVestRotation() {
      this.manualVestPeriod = this.period;
      this.isManualVest = true;
      this.doVestRotation();
    },
    submitDisputeMatch() {
      this.$store.commit("root/loading", true);
      this.$http
        .put(`/nrl/api/v1/admin/matches/${this.match._id}/status/disputed`, {
          note: this.dispute.reason,
        })
        .then(() => {
          this.match.status = "disputed";
          this.disputeDialog = false;
          this.resetDispute();
          this.$customSuccess();
          this.$router.push({
            name: "matches",
          });
          this.$store.commit("root/loading", false);
        })
        .catch(() => {
          this.$store.commit("root/loading", false);
        });
    },
    resetDispute() {
      this.dispute.reason = "";
    },
    toggleNetwork() {
      if (this.networkOnline) {
        this.outOfSync = true;
      }
      this.networkOnline = !this.networkOnline;
    },
    selectPlayer($event) {
      if (!$event.target.value) {
        return;
      }
      const player = JSON.parse($event.target.value);
      this.scoring.meta.player = player;
    },
    selectInterchange($event, type) {
      const player = JSON.parse($event.target.value);
      this.interchange.meta[type] = player;
    },
    matchTime(dateTime) {
      return this.dayjs(dateTime).format("h:mm a");
    },
    matchDate(dateTime) {
      return this.dayjs(dateTime).format("dddd Do MMMM");
    },
    updateGameState() {
      const type = this.period;
      if (this.match.scores) {
        this.match.scores.homeTeam = parseInt(this.match.scores.homeTeam);
        this.match.scores.awayTeam = parseInt(this.match.scores.awayTeam);
      }
      return new Promise((resolve) => {
        if (this.networkOnline) {
          this.$http
            .post(`nrl/api/v1/admin/matches/${this.match._id}/game-states`, {
              type,
              scores: this.match.scores,
            })
            .then((res) => {
              this.match.gameStates.push(res.data.data);
              EventBus.$emit("gamestate/update");
              if (type === 25) {
                this.match.status = "final";
                this.confirmEndGameDialog = false;
                this.$router.push({ name: "matches" });
              }
              resolve();
            })
            .catch(() => {
              resolve();
            });
        } else {
          const gameState = grassrootGameStates.find(x => x.type === type);
          this.match.gameStates.push({
            _id: generateHash({ length: 17 }),
            ...gameState,
            timestamp: dayjs().valueOf(),
          });
          if (type === 25) {
            this.match.status = "final";
            this.confirmEndGameDialog = false;
          }
          resolve();
        }
      });
    },
    confirmGameState(period) {
      if (period === this.period) {
        return;
      }
      const gameState = grassrootGameStates.find((obj) => obj.type === period);
      // < 25 Not Final
      if (period !== 25) {
        this.$confirm(`This will start the ${gameState.name}. Continue?`, "Warning")
          .then(() => {
            this.period = period;
            this.updateGameState().then(() => {
              // We manually select vest period because this functionality is reused for manual input
              this.manualVestPeriod = period;
              this.doVestRotation();
            });
          })
          .catch(() => { });
      } else {
        // 8 final state
        this.confirmEndGameDialog = true;
      }
      EventBus.$emit("gamestate/update");
    },
    doVestRotation() {
      if (this.availVestTypes.length) {
        const vestRotation = _.get(this.match, "meta.vestRotation");
        // populate
        for (const vestType of this.availVestTypes) {
          // eslint-disable-next-line no-loop-func
          const item =
            vestRotation &&
            vestRotation.find(
              (x) =>
                x.teamId === this.match.homeTeam._id &&
                x.vestType === vestType.type &&
                x.period === this.manualVestPeriod
            );
          if (item) this.homeVests.push({ ...item, period: this.manualVestPeriod });
          else {
            this.homeVests.push({
              player: undefined,
              teamId: this.match.homeTeam._id,
              vestType: vestType.type,
              period: this.manualVestPeriod,
            });
          }
        }
        // init for away
        for (const vestType of this.availVestTypes) {
          // eslint-disable-next-line no-loop-func
          const item =
            vestRotation &&
            vestRotation.find(
              (x) =>
                x.teamId === this.match.awayTeam._id &&
                x.vestType === vestType.type &&
                x.period === this.manualVestPeriod
            );
          if (item) this.awayVests.push({ ...item, period: this.manualVestPeriod });
          else {
            this.awayVests.push({
              player: undefined,
              teamId: this.match.awayTeam._id,
              vestType: vestType.type,
              period: this.manualVestPeriod,
            });
          }
        }
        this.vestRotationDialog = true;
      }
    },
    async submitVestRotation() {
      let data = this.homeVests.concat(this.awayVests);
      // filter empty player
      data = data
        .filter((x) => x.player)
        .map((x) => ({
          _id: generateHash({ length: 17 }),
          ...x,
        }));

      if (!data.length) {
        this.vestRotationDialog = false;
        return;
      }

      // add new data has players on recent period
      this.$set(
        this.match,
        "meta.vestRotation",
        _.get(this.match, "meta.vestRotation", [])
          .filter((x) => x.period !== this.manualVestPeriod)
          .concat(data)
      );

      // close popup
      this.vestRotationDialog = false;
      this.$forceUpdate();
      this.$http
        .post(`/nrl/api/v1/admin/matches/${this.match._id}/vest-rotation`, {
          vests: data,
        })
        .then(() => { })
        .catch(() => { });
      this.isManualVest = false;
    },
    removeVest(data) {
      this.$confirm("Are you sure you want to remove the vest rotation", "Remove Vest Rotation", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      }).then(() => {
        let vestRotation = Object.assign([], _.get(this.match, "meta.vestRotation", []));
        // remove on client side selected vest.
        vestRotation = vestRotation.filter((x) => x._id !== data._id);
        this.$set(this.match, "meta.vestRotation", vestRotation);
        this.$forceUpdate();
        this.$customSuccess();
        this.$http
          .delete(`/nrl/api/v1/admin/matches/${this.match._id}/vest-rotation/${data._id}`)
          .then(() => { })
          .catch(() => { });
      });
    },
    doInterchange(interchange) {
      if (!this.period || this.period === 99) {
        this.$customError(errormsg.invalid_period);
        return;
      }
      this.interchange = { ...this.interchange, ...interchange };
      this.interchange.meta.period = this.period;
      this.interchangeDialog = true;
    },
    doScoring(scoring) {
      if (this.match && !this.match.allowScoring) {
        this.$customError("The competition does not allow scoring");
        return;
      }

      if (!this.period || this.period === 99) {
        this.$customError(errormsg.invalid_period);
        return;
      }
      this.scoring = { ...this.scoring, ...scoring };
      this.scoring.meta.period = this.period;
      this.scoringDialog = true;
    },
    async submitScore() {
      const val = await this.$refs.scoring.validate().catch(() => { });
      if (val) {
        this.scoring._id = generateHash({ length: 17 });

        const events = _.filter(
          this.match.scoringEvents,
          (x) => x.isHomeTeam === this.scoring.isHomeTeam
        );
        const points = _.reduce(events, (acc, e) => acc + e.value, +this.scoring.value);

        if (this.scoring.isHomeTeam) this.match.scores.homeTeam = points;
        else this.match.scores.awayTeam = points;

        this.match.scoringEvents.push(_.cloneDeep(this.scoring));
        const preferFirstName =
          this.scoring?.meta?.player?.profile && this.scoring.meta.player.profile.preferNameStatus
            ? `${this.scoring.meta.player.profile.preferFirstName ||
            this.scoring.meta.player.profile.firstName ||
            ""
            }`
            : this.scoring?.meta?.player?.profile &&
              this.scoring.meta.player.profile.preferNameStatus === false
              ? `${this.scoring.meta.player.profile.firstName || ""}`
              : "";

        const preferLastName =
          this.scoring?.meta?.player?.profile && this.scoring.meta.player.profile.preferNameStatus
            ? `${this.scoring.meta.player.profile.preferLastName ||
            this.scoring.meta.player.profile.lastName ||
            ""
            }`
            : this.scoring?.meta?.player?.profile &&
              this.scoring.meta.player.profile.preferNameStatus === false
              ? `${this.scoring.meta.player.profile.lastName || ""}`
              : "";

        let preferredName = `${preferFirstName} ${preferLastName}`;
        if (preferredName == ! "") {
          this.scoring.meta.player.preferredName = preferredName;
        }

        const scoring = _.cloneDeep(this.scoring);

        scoring.min = parseInt(scoring.min);
        scoring.sec = parseInt(scoring.sec);

        this.scoringDialog = false;
        this.$customSuccess();
        if (this.networkOnline) {
          this.$http
            .post(`nrl/api/v1/admin/matches/scorings/${this.match._id}`, scoring)
            .then(() => {
              this.resetFields();
            })
            .catch(() => {
              this.resetFields();
            });
        } else {
          this.resetFields();
        }
      }
    },
    async submitInterchange() {
      const val = await this.$refs.interchange.validate().catch(() => { });
      if (val) {
        this.interchange._id = generateHash({ length: 17 });
        const interchange = _.cloneDeep(this.interchange);

        // Same logic as applied on the API
        const { type, meta } = interchange;
        const needPlayerOff = type === 14 || type === 17; // Sinbin && SendOff
        const needPlayerOn = type === 15; // Sin bin return to field
        if (needPlayerOff && (!meta || !meta.off)) {
          this.$customError(errormsg.player_off_req);
          return;
        }
        if (needPlayerOn && (!meta || !meta.on)) {
          this.$customError(errormsg.player_on_req);
          return;
        }

        this.interchangeDialog = false;
        if (typeof interchange.min === "string") interchange.min = parseInt(interchange.min);
        if (typeof interchange.sec === "string") interchange.sec = parseInt(interchange.sec);

        if (this.networkOnline) {
          this.$http
            .post(`nrl/api/v1/admin/matches/movements/${this.match._id}`, interchange)
            .then(() => {
              this.$customSuccess();
              this.match.playerMovements.push(interchange);
            })
            .catch(() => {
              this.$customError();
            });
        } else {
          this.resetFields();
        }
      }
    },
    removeEvent(eventid, isScoring) {
      if (isScoring) {
        this.$confirm(
          "Are you sure you want to remove this scoring event?",
          "Remove Scoring Event",
          { confirmButtonText: "OK", cancelButtonText: "Cancel" }
        )
          .then(() => {
            const scoring = this.match.scoringEvents.find((x) => x._id === eventid);
            const events = _.filter(
              this.match.scoringEvents,
              (x) => x.isHomeTeam === scoring.isHomeTeam
            );
            const points = _.reduce(events, (acc, e) => acc + e.value, -scoring.value);
            if (scoring.isHomeTeam) this.match.scores.homeTeam = points;
            else this.match.scores.awayTeam = points;

            this.match.scoringEvents = this.match.scoringEvents.filter((x) => x._id !== eventid);

            this.$customSuccess();
            if (this.networkOnline) {
              this.$http
                .delete(`nrl/api/v1/admin/matches/scorings/${this.match._id}`, {
                  data: { eventid },
                })
                .then(() => { })
                .catch(() => {
                  this.$customError();
                });
            }
          })
          .catch(() => { });
      } else {
        this.$confirm(
          "Are you sure you want to remove this interchange event?",
          "Remove Interchange Event",
          { confirmButtonText: "OK", cancelButtonText: "Cancel" }
        )
          .then(() => {
            this.match.playerMovements = this.match.playerMovements.filter(
              (x) => x._id !== eventid
            );
            this.$customSuccess();
            if (this.networkOnline) {
              this.$http
                .delete(`nrl/api/v1/admin/matches/movements/${this.match._id}`, {
                  data: { eventid },
                })
                .then(() => { })
                .catch(() => {
                  this.$customError();
                });
            }
          })
          .catch(() => { });
      }
    },
    preventNav(e) {
      const confirmationMessage = "Are you sure you want to leave this page?";
      (e || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    },
    vestHomePlayers(index, list) {
      const selectedPlayers = this.homeVests.map((x) => (x.player && x.player._id) || null);
      const recentPlayer = this.homeVests[index].player && this.homeVests[index].player._id;
      return list.filter((y) => y._id === recentPlayer || !selectedPlayers.includes(y._id));
    },
    vestAwayPlayers(index, list) {
      const selectedPlayers = this.awayVests.map((x) => (x.player && x.player._id) || null);
      const recentPlayer = this.awayVests[index].player && this.awayVests[index].player._id;
      return list.filter((y) => y._id === recentPlayer || !selectedPlayers.includes(y._id));
    },
    onPlayers(list) {
      return this.interchange.meta.off
        ? list.filter((x) => x._id !== this.interchange.meta.off._id)
        : list;
    },
    offPlayers(list) {
      return this.interchange.meta.on
        ? list.filter((x) => x._id !== this.interchange.meta.on._id)
        : list;
    },
    formatTime(int) {
      return int < 10 ? `0${int}` : int;
    },
    resetFields() {
      this.scoring._id = null;

      this.scoring.min = 0;
      this.scoring.sec = 0;
      this.interchange._id = null;
      this.interchange.min = null;
      this.interchange.sec = null;
    },
    formatVestLabel(vestType) {
      const vest = vestTypes.find((x) => x.type === vestType);
      return vest ? vest.name : "N/A";
    },
    displayPlayerName(profile) {
      const preferFirstName = profile && profile.preferNameStatus
        ? `${profile.preferFirstName || profile.firstName || ''}`
        : profile && profile.preferNameStatus === false
          ? `${profile.firstName || ''}`
          : '';

      const preferLastName = profile && profile.preferNameStatus
        ? `${profile.preferLastName || profile.lastName || ''}`
        : profile && profile.preferNameStatus === false
          ? `${profile.lastName || ''}`
          : '';

      const prefferedName = `${preferFirstName} ${preferLastName}`;
      return prefferedName;
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    window.addEventListener("online", this.toggleNetwork);
    window.addEventListener("offline", this.toggleNetwork);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
    window.removeEventListener("online", this.toggleNetwork);
    window.removeEventListener("offline", this.toggleNetwork);
  },
  beforeRouteLeave(to, from, next) {
    const confirmationMessage = this.networkOnline
      ? "Are you sure you want to leave this page?"
      : "You are currently offline, if you exit this page all changes will be lost. Continue?";
    this.$confirm(confirmationMessage, "Warning")
      .then(() => {
        // Preventing Vue from creating new instance when doing route push
        const eventName = `${this.$route.name}-header-menu`;
        this.$root.$off(eventName);
        next();
      })
      .catch(() => { });
  },
  computed: {
    isFinal() {
      return this.match.status === "final";
    },
    syncStatus() {
      const { networkOnline, outOfSync } = this;
      if (networkOnline && outOfSync) return "syncing";
      if (networkOnline && !outOfSync) return "synced";
      if (!networkOnline) return "out-of-sync";
      return "";
    },
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
    feedEvents() {
      let feeds =
        this.match &&
        this.match.scoringEvents
          .map((x) => ({ ...x, isScoring: true }))
          .concat(this.match.playerMovements || []);
      if (feeds && feeds.length) feeds = _.sortBy(feeds, "min", "sec");
      return feeds;
    },
    vests: {
      cache: false,
      get() {
        if (!this.availVestTypes.length) {
          return [];
        }
        let vests = _.get(this.match, "meta.vestRotation", []);
        vests = vests.map((x) => {
          const state = grassrootGameStates.find((y) => y.type === x.period);
          return {
            ...x,
            playerName: x.player
              ? `${x.player.firstName} ${x.player.lastName} #${x.player.shirtNum}`
              : "",
            periodName: state ? state.name : "",
            teamName: this.match.homeTeam._id === x.teamId ? "HOME" : "AWAY",
          };
        });

        if (vests && vests.length) vests = _.sortBy(vests, "period");
        return vests;
      },
    },
    playerScoring() {
      return this.$store.getters["user/activeRole"].national_id === 32 ? nrlScoring : tfaScoring;
    },
    playerInterchanges() {
      return this.$store.getters["user/activeRole"].national_id === 32
        ? interchanges
        : interchanges.filter((o) => o.type === 16); // Send Off/Dismissal
    },
  },
  watch: {
    manualVestPeriod(val) {
      this.homeVests = this.homeVests.map((v) => ({ ...v, period: val }));
      this.awayVests = this.awayVests.map((v) => ({ ...v, period: val }));
    },
    networkOnline: {
      handler(val) {
        const { outOfSync } = this;
        if (val && outOfSync) {
          const { _id, playerMovements, scoringEvents, status, gameStates, meta } = this.match;
          const { vestRotation } = meta;
          this.$http
            .post(`/nrl/api/v1/admin/matches/sync/${_id}`, {
              playerMovements,
              scoringEvents,
              status,
              gameStates,
              vestRotation,
            })
            .then(() => {
              this.outOfSync = false;
            })
            .catch(() => { });
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.el-col .el-col-24 {
  margin: 5px 0px;
}

.el-select,
.el-input-number {
  width: 100%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.input {
  @apply tw-w-full tw-px-2 tw-text-sm tw-text-gray-800 tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

.textBox {
  @apply tw-w-full tw-p-2 tw-text-sm tw-text-gray-800 tw-placeholder-gray-800 tw-bg-transparent tw-border tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}

select {
  appearance: none;
  /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg");
  /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
  @apply tw-w-full tw-px-2 tw-text-sm tw-placeholder-gray-800 tw-text-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none focus:tw-outline-none tw-h-9;
}

.btn-success {
  @apply tw-justify-center tw-w-full tw-mt-6 tw-mr-2.5 tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}

.btn-cancel {
  @apply tw-justify-center tw-w-full tw-bg-none tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-black tw-border-2 tw-border-green-700 hover:tw-border-green-300 sm:tw-w-64;
}

.button-container {
  text-align: center;

  .el-button+.el-button {
    margin-left: 5px;
  }

  .el-button {
    font-size: 0.65em;
    width: 23.5%;
    padding: 10px 5px !important;
    letter-spacing: 0.01rem;
    border-radius: 0px;
  }

  .el-button--default {
    border: 2px solid $primary !important;
    margin-top: 10px;
  }

  .el-button--success {
    border: 2px solid $nrlGreen !important;
  }
}

.is-disabled {
  border: none !important;
  background: #d3d3d3 !important;
  color: black !important;

  &:focus {
    color: black !important;
  }
}

.el-tabs {
  ::v-deep .el-tabs__header {
    text-align: center;

    .el-tabs__active-bar {
      background: none;
      z-index: 0;
    }

    .el-tabs__nav {
      width: 100%;

      .el-tabs__item {
        padding: 0px;
      }
    }
  }
}

.icon {
  font-size: 2rem;
}

.icon:hover {
  cursor: pointer;
}

.el-icon-circle-plus {
  color: $nrlGreen;
}

.el-icon-remove {
  color: red;
}

::v-deep .event-label {
  text-transform: uppercase;
  font-weight: 500;
  color: $primary;
}

::v-deep .el-dialog {
  width: 90vw !important;

  z-index: 5000 !important;

  .el-dialog__body {
    padding: 0px 20px 15px 20px;
  }
}

.online-status-bar {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  margin-bottom: -10px;

  .status {
    border-left: 3px solid $primary;
    border-right: 3px solid $primary;
    border-top: 3px solid $primary;
    border-radius: 10px 10px 0px 0px;
    overflow: hidden;

    .online {
      width: 50px;
      height: 50px;
      background-color: $nrlGreen-highlight;
      border-right: 2px solid white;
      font-size: 24px;

      &.off {
        background-color: red;
      }
    }

    .saved {
      height: 50px;
      width: 150px;
      background-color: $nrlGreen-highlight;
      text-transform: uppercase;
      font-weight: bold;

      &.synced,
      &.syncing {
        background-color: $nrlGreen-highlight;
        color: black;
      }

      &.out-of-sync {
        background-color: red;
        color: white;
      }
    }

    .auto-margin {
      margin: auto;
    }
  }
}

.add-vest-rotation {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}

::v-deep .el-dialog__wrapper .el-form-item {
  margin-bottom: 0px;
}
</style>
